import { render, staticRenderFns } from "./BuyCourseArea.vue?vue&type=template&id=908f3050&scoped=true&"
import script from "./BuyCourseArea.vue?vue&type=script&lang=js&"
export * from "./BuyCourseArea.vue?vue&type=script&lang=js&"
import style0 from "./BuyCourseArea.vue?vue&type=style&index=0&id=908f3050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908f3050",
  null
  
)

export default component.exports